import { useTranslation } from "react-i18next";

function TitleOfSection(props) {
  const { t } = useTranslation();
  return (
    <div className="section-tilte mt-3">
      <div className="d-flex">
        {/* <span>{props.name} </span> */}
        <h2> {props.title}</h2>
      </div>
      {/* <div className="line"></div> */}
    </div>
  );
}
export default TitleOfSection;